import React from 'react';
import { Link } from 'react-router-dom';

/** Single link column in the footer */
interface LinkColumn {
  title: string;
  links: { label: string; to: string }[];
}

const columns: LinkColumn[] = [
  {
    title: 'Calculators',
    links: [
      { label: 'Finance', to: '/calculators/financial-tools' },
      { label: 'Health', to: '/calculators/health-wellness' },
      { label: 'Education', to: '/calculators/education' },
      { label: 'Lifestyle', to: '/calculators/lifestyle' },
      { label: 'Professional', to: '/calculators/professional-tools' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Privacy Policy', to: '/privacy-policy' },
      { label: 'Terms of Use', to: '/terms-of-use' },
      { label: 'Sitemap', to: '/sitemap' },
    ],
  },
];

/**
 * Footer quick-link columns — calculator categories + legal/company links.
 */
const FooterLinks: React.FC = () => {
  return (
    <>
      {columns.map((col) => (
        <div key={col.title}>
          <h4 className="font-semibold text-foreground text-sm mb-3">{col.title}</h4>
          <ul className="space-y-2">
            {col.links.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-muted-foreground text-sm hover:text-primary transition-colors"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
};

export default FooterLinks;
